export default "__VITE_ASSET__d88fdf47__"